import { createRouter, createWebHashHistory } from 'vue-router';
import { createApp } from 'vue'

const routes = [
  {
    path: '/',
    component: () => import('../components/appLayout'),
    redirect: window.innerWidth > 768 ? '/index' : '/transitionpage',
    children: [
      // 中间页
      {
        path: '/transitionpage',
        component: () => import('../pages/TransitionPage'),
      },
      {
        path: '/index',
        component: () => import('../pages/index/Index'),

      },
      // 登录
      {
        path: '/login',
        component: () => import('../pages/uc/Login'),

      },
      // 注册
      {
        path: '/register',
        component: () => import('../pages/uc/Register'),

      },
      // 找回账号私钥
      {
        path: '/retrieveprivate',
        component: () => import('../pages/uc/RetrievePrivateKey'),

      },
      // 重置密码
      {
        path: '/findPwd',
        component: () => import('../pages/uc/FindPwd'),
      },
      // APP 下载
      {
        path: '/app',
        component: () => import('../pages/uc/AppDownload'),
      },

      // ----- 模拟交易页面 -----
      {
        path: '/mock',
        component: () => import('../pages/mockTrading'),
        redirect: '/mock/swap',
        children: [
          // U本位
          {
            path: 'swap',
            component: () => import('../pages/swap'),
          },
          {
            path: '/mock/swap/:pair',
            component: () => import('../pages/swap'),
            name: 'mock_SwapPair',
          },
          // 币本位
          {
            path: 'coinswap',
            component: () => import('../pages/coinswap'),
          },
          {
            path: '/mock/coinswap/:pair',
            component: () => import('../pages/coinswap'),
            name: 'mock_CoinSwapPair',
          },
          // 秒合约
          {
            path: 'second',
            component: () => import('../pages/second'),
          },
          {
            path: '/mock/second/:pair',
            component: () => import('../pages/second'),
            name: 'mock_SecondPair',
          },
          // 期权合约
          {
            path: 'option',
            component: () => import('../pages/option'),
          },
          //我的资产
          {
            path: 'management',
            component: () => import('../pages/management'),
          },
          //划转
          {
            path: 'transfer',
            component: () => import('../pages/uc2/transfer'),
          },
          // 关于我们、联系我们
          {
            path: 'aboutUS',
            component: () => import('../pages/rule/aboutUS'),
          },
          // aboutUZX
          {
            path: 'about',
            component: () => import('../pages/rule/aboutUZX'),
          },
          // 社群
          {
            path: 'community',
            component: () => import('../pages/community/community'),
          },
          // 交易费率
          {
            path: 'TransactionRate',
            component: () => import('../pages/TransactionRate/TransactionRate'),
          },
        ],
      },

      // ----- 交易页面 -----
      // 币币
      {
        path: '/exchange',
        component: () => import('../pages/exchange'),
      },
      {
        path: '/exchange/:pair',
        component: () => import('../pages/exchange'),
        name: 'ExchangePair',
      },
      // U本位
      {
        path: '/swap',
        component: () => import('../pages/swap'),
      },
      {
        path: '/swap/:pair',
        component: () => import('../pages/swap'),
        name: 'SwapPair',
      },
      // 币本位
      {
        path: '/coinswap',
        component: () => import('../pages/coinswap'),
      },
      {
        path: '/coinswap/:pair',
        component: () => import('../pages/coinswap'),
        name: 'CoinSwapPair',
      },
      // 秒合约
      {
        path: '/second',
        component: () => import('../pages/second'),
      },
      {
        path: '/second/:pair',
        component: () => import('../pages/second'),
        name: 'SecondPair',
      },
      // 期权合约
      {
        path: '/option',
        component: () => import('../pages/option'),
      },

      // --- h5的路由，pc手机适配嵌套时路由处理 ---
      {
        path: '/m',
        component: () => import('../pages/h5Page'),
        children: [
          {
            path: '/m/trade',
            redirect: '/m/trade/cointrade',
            component: () => import('../pages/h5Page'),
            children: [
              {
                path: '/m/trade/cointrade',
                component: () => import('../pages/h5Page'),
              },
              {
                path: '/m/trade/flashexchange',
                component: () => import('../pages/h5Page'),
              },
            ],
          },
          {
            path: '/m/contract',
            redirect: '/m/contract/usdtcontract',
            component: () => import('../pages/h5Page'),
            children: [
              {
                path: '/m/contract/usdtcontract',
                component: () => import('../pages/h5Page'),
              },
              {
                path: '/m/contract/coincontract',
                component: () => import('../pages/h5Page'),
              },
              {
                path: '/m/contract/optioncontract',
                component: () => import('../pages/h5Page'),
              },
              {
                path: '/m/contract/secondcontract',
                component: () => import('../pages/h5Page'),
              },
            ],
          },
          {
            path: 'klineinfodetail',
            component: () => import('../pages/h5Page'),
          },
          {
            path: 'accessdetail',
            component: () => import('../pages/h5Page'),
          },
          {
            path: 'tradelog',
            component: () => import('../pages/h5Page'),
          },
          {
            path: 'allentrust',
            component: () => import('../pages/h5Page'),
          },
          {
            path: 'billing',
            component: () => import('../pages/h5Page'),
          },
          {
            path: 'helpdoc',
            component: () => import('../pages/h5Page'),
          },
          {
            path: 'contracthistoryentrustall',
            component: () => import('../pages/h5Page'),
          },
          {
            path: 'secondentrustall',
            component: () => import('../pages/h5Page'),
          },
        ],
      },
      {
        path: '/klineinfodetail',
        redirect: '/m/klineinfodetail',
      },
      {
        path: '/accessdetail',
        redirect: '/m/accessdetail',
      },
      {
        path: '/tradelog',
        redirect: '/m/tradelog',
      },
      {
        path: '/allentrust',
        redirect: '/m/allentrust',
      },
      {
        path: '/billing',
        redirect: '/m/billing',
      },
      {
        path: '/helpdoc',
        redirect: '/m/helpdoc',
      },
      {
        path: '/contracthistoryentrustall',
        redirect: '/m/contracthistoryentrustall',
      },
      {
        path: '/secondentrustall',
        redirect: '/m/secondentrustall',
      },
      // h5的路由，pc手机适配嵌套时路由处理  -----end-----

      {
        path: '/notice',
        component: () => import('../pages/cms/Notice'),
      },
      //详情页
      {
        path: '/finanIndex',
        component: () => import('../pages/finance/finanIndex'),
      },
      //金融Launchpad
      {
        path: '/financeLaunchpad',
        component: () => import('../pages/finance/financeLaunchpad'),
      },
      // 邀请好友页面
      {
        path: '/invite',
        component: () => import('../pages/invite/Invite'),
      },
      // 规则说明文章
      {
        path: '/ruleInfo',
        component: () => import('../pages/invite/ruleInfo'),
      },
      // UZX返佣规则说明
      {
        path: '/ruleInfo2',
        component: () => import('../pages/invite/ruleInfo2'),
      },
      // 奖励中心 Rewards
      {
        path: '/rewards',
        component: () => import('../pages/rewards'),
        children: [
          // 奖励列表
          {
            path: '',
            component: () => import('../pages/rewards/rewards'),
          },
          // 问题列表
          {
            path: 'problem',
            component: () => import('../pages/rewards/problem'),
          },
        ],
      },
      // UZX LAB
      {
        path: '/uzxLab',
        component: () => import('../pages/uzxLab'),
      },
      // UZX用户首次入金奖励说明
      {
        path: '/rewardsArticle',
        component: () => import('../pages/rewards/article'),
      },
      // 闪兑
      {
        path: '/cexchange',
        component: () => import('../pages/cexchange/cexchange'),
      },
      // 公告详情
      {
        path: '/announcement/:id',
        component: () => import('../pages/cms/NoticeItemDetail'),
        name: 'NoticeDetail',
      },
      // 公告列表
      {
        path: '/noticeItem/:id',
        component: () => import('../pages/cms/NoticeItem'),
      },
      // 安全中心personalCenter
      {
        path: '/personalCenter',
        component: () => import('../pages/personalCenter/securityCenter'),
      },
      // 安全中心→邮箱绑定
      {
        path: '/emailCenter',
        component: () => import('../pages/personalCenter/emailCenter'),
      },
      {
        path: '/authenticationCenter',
        component: () => import('../pages/personalCenter/authenticationCenter'),
      },
      {
        path: '/phoneCenter',
        component: () => import('../pages/personalCenter/phoneCenter'),
      },
      // 新 充币页面
      {
        path: '/recharge',
        component: () => import('../pages/recharge'),
      },
      // 新 提币页面
      {
        path: '/withdraw',
        component: () => import('../pages/withdraw'),
      },
      // 划转
      {
        path: '/transfer',
        component: () => import('../pages/uc2/transfer'),
      },
      // 我的资产
      {
        path: '/management',
        component: () => import('../pages/management'),
      },
      // 存币生息
      {
        path: '/saveCoins',
        component: () => import('../pages/saveCoins/saveCoin'),
      },
      // 我的订单
      {
        path: '/myOrder',
        component: () => import('../pages/myOrder/myOrder'),
      },
      // 合伙计划
      {
        path: '/partner',
        component: () => import('../pages/partner'),
      },
      // 合伙计划规则
      {
        path: '/rule',
        component: () => import('../pages/rule/rule'),
      },
      // 帮助中心
      {
        path: '/helpCenter',
        component: () => import('../pages/helpCenter/helpCenter'),
      },
      // 更多问题
      {
        path: '/moreProblem',
        component: () => import('../pages/moreProblem/moreProblem'),
      },
      // 行情>市场
      {
        path: '/price/market',
        component: () => import('../pages/price/market'),
      },
      // 行情>机会
      {
        path: '/price/chance',
        component: () => import('../pages/price/chance'),
      },
      // 更多问题->文章
      {
        path: '/article',
        component: () => import('../pages/article/article'),
      },
      // 帮助中心->搜索
      {
        path: '/searchResults',
        component: () => import('../pages/searchResults/searchResults'),
      },
      // 反馈意见
      {
        path: '/feedBack',
        component: () => import('../pages/feedBack/feedBack'),
      },
      // 我的工单
      {
        path: '/MyWorkOrder',
        component: () => import('../pages/myWorkOrder/myWorkOrder'),
      },
      // 我的工单详情
      {
        path: '/detail',
        component: () => import('../pages/myWorkOrder/detail'),
      },
      // 社群
      {
        path: '/community',
        component: () => import('../pages/community/community'),
      },
      // 新手社区
      {
        path: '/noviceCommunity',
        component: () => import('../pages/noviceCommunity/noviceCommunity'),
      },
      // 新手社区->查看更多
      {
        path: '/moreDetials',
        component: () => import('../pages/noviceCommunity/moreDetials'),
      },
      // UZX Dao
      {
        path: '/UZXDao',
        component: () => import('../pages/UZXDao/UZXDao'),
      },
      // aboutUZX
      {
        path: '/about',
        component: () => import('../pages/rule/aboutUZX'),
      },
      // 关于我们、联系我们
      {
        path: '/aboutUS',
        component: () => import('../pages/rule/aboutUS'),
      },
      // 交易费率
      {
        path: '/TransactionRate',
        component: () => import('../pages/TransactionRate/TransactionRate'),
      },
      // 官方验证渠道
      {
        path: '/officialChannel',
        component: () => import('../pages/officialChannel'),
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  next();
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router;
